<template>
	<div class="homedemo_pages">
		<div class="home_top_block">
			<!-- <div class="home_top_search_box">motortime.com</div> -->
			<div class="swiper_box">
				<van-swipe class="my_swipe" :autoplay="5000" :height="285" indicator-color="#FFBB00">
					<van-swipe-item v-for="item in sliders" :key="'swipe_' + item.id">
						<a :href="'https://m.motortime.com/article/' + item.id + '/post'">
							<img class="swipe_img" v-lazy="item.m_pic_url ? item.m_pic_url : item.pic_url" :id="item.id"
								:name="item.module.id">
						</a>
					</van-swipe-item>
				</van-swipe>
			</div>
			<div class="home_headline_box">
				<!-- <div class="home_headline_icon_box">
				<img class="home_headline_icon" :src="img.headline_img">	
			</div> -->
				<img class="home_headline_icon" :src="img.headline_img">
				<div class="home_headline_title_box">
					<van-swipe class="my_swipe" width="100%" :autoplay="1000" vertical :show-indicators="false"
						:initial-swipe="headlinesNum">
						<van-swipe-item v-for="item in headlinesList" :key="item.z_id">
							<a :href="'https://m.motortime.com/article/' + item.z_id + '/post'"
								class="home_headline_article_block ellipsis">
								{{ item.archives_title }}
							</a>
						</van-swipe-item>
					</van-swipe>
				</div>
			</div>
		</div>
		<div class="home_list_box">
			<div class="home_channel_box">
				<div class="display_flex">
					<div v-for="item in index_label_list" :key="item.id" class="home_channel_cell">
						<div v-if="item.isShow" @click="changeLabel(item.id, item.title)">
							<div
								:class="item.id == params.type ? 'home_channel_title home_channel_title_on' : 'home_channel_title'">
								{{ item.title }}</div>
							<div
								:class="item.id == params.type ? 'home_channel_border home_channel_border_on' : 'home_channel_border'">
							</div>
						</div>
						<div v-else>
							<div class="home_channel_title_def">{{ item.title }}</div>
							<div class="home_channel_border"></div>
						</div>
					</div>
				</div>
				<div v-if="lable_name == '视频'" class="display_flex mt-10">
					<div class="home_channel_cell" @click="changeChildLabel(0)">
						<div
							:class="params.source == 0 ? 'home_channel_title home_channel_title_on' : 'home_channel_title'">
							汽车时间</div>
						<div
							:class="params.source == 0 ? 'home_channel_border home_channel_border_on' : 'home_channel_border'">
						</div>
					</div>
					<div class="home_channel_cell" @click="changeChildLabel(29)">
						<div
							:class="params.source == 29 ? 'home_channel_title home_channel_title_on' : 'home_channel_title'">
							DrivingArt</div>
						<div
							:class="params.source == 29 ? 'home_channel_border home_channel_border_on' : 'home_channel_border'">
						</div>
					</div>
					<div class="home_channel_cell" @click="changeChildLabel(30)">
						<div
							:class="params.source == 30 ? 'home_channel_title home_channel_title_on' : 'home_channel_title'">
							伞轮儿</div>
						<div
							:class="params.source == 30 ? 'home_channel_border home_channel_border_on' : 'home_channel_border'">
						</div>
					</div>
				</div>
			</div>
			<div v-if="lable_name == '直播'" class="artlcie_list_box">
				<van-list v-model="loadingl" :finished="finishedl" finished-text="没有更多了" @load="onLoadl">
					<div slot="loading" class="list-loading">
						<img :src="this.img.loadingl" />
						<span>正在刷新</span>
					</div>
					<div v-for="item in livelist" :key="'zb_' + item.id" class="artlcie_list_cell">
						<a :href="'https://m.motortime.com/live/' + item.key">
							<div class="list_bigimg_top">
								<div class="artlcie_list_title">{{ item.title }}
									<img v-if="item.live_status == 0" class="artlcie_list_type_icon"
										:src="img.live_advance">
									<img v-else class="artlcie_list_type_icon" :src="img.live_icon">
								</div>

							</div>
							<div class="list_bigimg_center">
								<img v-if="item.live_status == 0" class="list_bigimg_img"
									:src="item.start_pic ? item.start_pic : img.default_img">
								<img v-if="item.live_status == 1" class="list_bigimg_img"
									:src="item.live_start_pic ? item.live_start_pic : img.default_img">
								<img v-if="item.live_status == 2" class="list_bigimg_img"
									:src="item.live_end_pic ? item.live_end_pic : img.default_img">
								<img v-if="item.live_status == 0" class="list_bigimg_inicon" :src="img.live_advanced">
								<img v-if="item.live_status == 1" class="list_bigimg_inicon" :src="img.liveing_icon">
								<img v-if="item.live_status == 2" class="list_bigimg_inicon" :src="img.liveend_icon">
							</div>
							<div class="list_bigimg_bottom">
								<div class="list_bigimg_bottom_text">{{ item.media_title }}</div>
								<div class="display_flex">
									<img class="read_icon" :src="img.read_icon">
									<div class="list_bigimg_bottom_text">{{ item.watch_num }}</div>
								</div>
								<!-- <div class="display_flex">
							<img class="comment_icon" :src="img.comment_icon">
							<div class="list_bigimg_bottom_text">{{item.reply_num}}</div>
						</div>
						<div class="list_bigimg_bottom_text">{{item.time_format}}</div> -->
							</div>
						</a>
					</div>
				</van-list>
			</div>
			<div v-else class="artlcie_list_box">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
					<div slot="loading" class="list-loading">
						<img :src="this.img.loading" />
						<span>正在刷新</span>
					</div>

					<div v-for="item in list" :key="`${item.id}-${params.type}`" class="artlcie_list_cell">
						<a :href="'https://m.motortime.com/article/' + item.id + '/post'" v-if="item.module.id == 1">
							<van-row :gutter="8">
								<van-col span="16">
									<div class="artlcie_list_left">
										<div class="list_bigimg_top">
											<div class="artlcie_list_title ellipsis-2">
												{{ item.title }} <img class="artlcie_list_type_icon"
													:src="img.imgtext_icon">
											</div>
										</div>
										<div class="ellipsis-2 artlcie_list_desc">{{ item.description }}</div>
										<div class="artlcie_list_left_bottom">
											<div class="list_bigimg_bottom_text">{{ item.media.name }}</div>
											<div class="display_flex">
												<img class="read_icon" :src="img.read_icon">
												<div class="list_bigimg_bottom_text">{{ item.click }}</div>
											</div>
											<!-- <div class="display_flex">
									<img class="comment_icon" :src="img.comment_icon">
									<div class="list_bigimg_bottom_text">{{item.reply_num}}</div>
								</div>
								<div class="list_bigimg_bottom_text" style="margin-right:0px;">{{item.time_format}}</div> -->
										</div>
									</div>
								</van-col>
								<van-col span="8">
									<div class="moreimg_cell">
										<img class="moreimg_img" :src="item.pic_url ? item.pic_url : img.default_img">
										<img class="samll_img_right_icon" :src="img.samll_moreimg_icon">
									</div>
								</van-col>
							</van-row>
						</a>
						<a :href="'https://m.motortime.com/article/' + item.id + '/post'" v-if="item.module.id == 2">
							<div class="list_bigimg_top">
								<div class="artlcie_list_title ellipsis-4">{{ item.title }}
									<img class="artlcie_list_type_icon" :src="img.moreimg_icon">
								</div>
							</div>
							<div class="list_bigimg_center">
								<van-row :gutter="8">
									<van-col span="8">
										<div class="moreimg_cell">
											<img class="moreimg_img" :src="item.all_pics[0]">
										</div>
									</van-col>
									<van-col span="8">
										<div class="moreimg_cell">
											<img class="moreimg_img" :src="item.all_pics[1]">
										</div>
									</van-col>
									<van-col span="8">
										<div class="moreimg_cell">
											<img class="moreimg_img" :src="item.all_pics[2]">
											<img class="samll_img_right_icon" :src="img.samll_moreimg_icon">
										</div>
									</van-col>
								</van-row>
							</div>
							<div class="list_bigimg_bottom">
								<div class="list_bigimg_bottom_text">{{ item.media.name }}</div>
								<div class="display_flex">
									<img class="read_icon" :src="img.read_icon">
									<div class="list_bigimg_bottom_text">{{ item.click }}</div>
								</div>
								<!-- <div class="display_flex">
						<img class="comment_icon" :src="img.comment_icon">
						<div class="list_bigimg_bottom_text">{{item.reply_num}}</div>
					</div>
					<div class="list_bigimg_bottom_text">{{item.time_format}}</div> -->
							</div>
						</a>
						<a :href="'https://m.motortime.com/article/' + item.id + '/post'" v-if="item.module.id == 3">
							<div class="list_bigimg_top">
								<div class="artlcie_list_title">{{ item.title }}
									<img class="artlcie_list_type_icon" :src="img.video_icon">
									<!-- <img class="artlcie_list_type_icon" :src="img.live_icon"> -->
								</div>
							</div>
							<div class="list_bigimg_center">
								<img class="list_bigimg_img" :src="item.pic_url ? item.pic_url : img.default_img">
								<img class="list_bigimg_player" :src="img.player_icon">
								<!-- <img class="list_bigimg_inicon" :src="img.liveing_icon"> -->
							</div>
							<div class="list_bigimg_bottom">
								<div class="list_bigimg_bottom_text">{{ item.media.name }}</div>
								<div class="display_flex">
									<img class="read_icon" :src="img.read_icon">
									<div class="list_bigimg_bottom_text">{{ item.click }}</div>
								</div>
								<!-- <div class="display_flex">
						<img class="comment_icon" :src="img.comment_icon">
						<div class="list_bigimg_bottom_text">{{item.reply_num}}</div>
					</div>
					<div class="list_bigimg_bottom_text">{{item.time_format}}</div> -->
							</div>
						</a>
					</div>
				</van-list>
			</div>
		</div>
	</div>
</template>
<script>
import content from '../../api/content';
import wxShare from '../../api/wxShare';
import { mapState } from 'vuex';
import { Swipe, SwipeItem, List, Row, Col, Tag, Popup, ImagePreview } from "vant";
import Search from './Common/Search';
export default {
	components: {
		[Swipe.name]: Swipe,
		[SwipeItem.name]: SwipeItem,
		[Row.name]: Row,
		[Col.name]: Col,
		[List.name]: List,
		[Tag.name]: Tag,
		[Popup.name]: Popup,
		[ImagePreview.name]: ImagePreview
	},
	data() {
		return {
			params: {
				type: 0,
				page: 1,
				user_id: 0,
				source: 0,
			},
			list: [],
			loading: false,
			finished: false,
			sliders: [],
			headlinesList: [],
			headlinesNum: 0,
			index_label_list: [{
				id: 0,
				title: '推荐',
				isShow: true
			}, {
				id: 1,
				title: '资讯',
				isShow: true
			}, {
				id: 2,
				title: '评测',
				isShow: true
			}, {
				id: 3,
				title: '视频',
				isShow: true
			}, {
				id: 4,
				title: '直播',
				isShow: true
			}],
			paramsl: {
				page: 1,
			},
			livelist: [],
			lable_name: '',
			finishedl: false,
			loadingl: false,
			img: {
				parise: require('../../assets/img/parise.png'),
				parise_have: require('../../assets/img/parise_have.png'),
				comment: require('../../assets/img/comment.png'),
				loading: require('../../assets/img/loading.gif'),
				wechateq: require('../../assets/img/wechateq.png'),
				hot_right_top: require('../../assets/img/hoime_icon/hot_right_top.png'),
				headline_img: require('../../assets/img/hoime_icon/headline_img.png'),
				liveing_icon: require('../../assets/img/hoime_icon/liveing_icon.gif'),
				live_icon: require('../../assets/img/hoime_icon/live_icon.png'),
				liveend_icon: require('../../assets/img/hoime_icon/liveend_icon.png'),
				live_advance: require('../../assets/img/hoime_icon/live_advance.png'),
				live_advanced: require('../../assets/img/hoime_icon/live_advanced.png'),
				active_icon: require('../../assets/img/hoime_icon/active_icon.png'),
				advance_icon: require('../../assets/img/hoime_icon/advance_icon.png'),
				bbs_icon: require('../../assets/img/hoime_icon/bbs_icon.png'),
				goods_icon: require('../../assets/img/hoime_icon/goods_icon.png'),
				imgtext_icon: require('../../assets/img/hoime_icon/imgtext_icon.png'),
				moreimg_icon: require('../../assets/img/hoime_icon/moreimg_icon.png'),
				player_icon: require('../../assets/img/hoime_icon/player_icon.png'),
				recruit_icon: require('../../assets/img/hoime_icon/recruit_icon.png'),
				samll_active_icon: require('../../assets/img/hoime_icon/samll_active_icon.png'),
				samll_bbs_icon: require('../../assets/img/hoime_icon/samll_bbs_icon.png'),
				samll_goods_icon: require('../../assets/img/hoime_icon/samll_goods_icon.png'),
				samll_imgtext_icon: require('../../assets/img/hoime_icon/samll_imgtext_icon.png'),
				samll_moreimg_icon: require('../../assets/img/hoime_icon/samll_moreimg_icon.png'),
				samll_recruit_icon: require('../../assets/img/hoime_icon/samll_recruit_icon.png'),
				video_icon: require('../../assets/img/hoime_icon/video_icon.png'),
				read_icon: require('../../assets/img/hoime_icon/read_icon.png'),
				comment_icon: require('../../assets/img/hoime_icon/comment_icon.png'),
			}
		}
	},
	created() {
		content.getShare({ url: encodeURI(location.href) }).then(res => {
			if (res.data.state == 1) {
				wxShare.getJSSDK(res.data.data, {
					'title': '汽车时间_属于你的汽车时间_motortime.com',
					'description': '汽车时间，提供汽车行业有特色的新闻资讯、汽车图片、要闻推送；同时，还有线下车友活动组织、线上汽车商品促销信息，满足您对汽车资讯需要。',
					'share_image': 'https://pic.motortime.com/static/motortime_uni/logo.png'
				})
			}
		})
		this.getHomeList()
		this.getSlider()
		this.getHeadlinesList()
	},
	methods: {
		getHomeList() {
			this.params.user_id = this.user ? this.user.id : 0
			content.getHomeList(this.params).then(res => {
				this.list.push.apply(this.list, res.data.data)
				this.loading = false
				if (res.data.data.length == 0) {
					this.finished = true
				}
			})
		},
		getLiveList() {
			this.paramsl.user_id = this.user ? this.user.id : 0
			content.getLiveList(this.paramsl).then(res => {
				console.log(res)
				this.livelist.push.apply(this.livelist, res.data.data.data)
				console.log(this.livelist)
				this.loadingl = false
				if (res.data.data.data.length == 0) {
					this.finishedl = true
				}
			})
		},
		getHeadlinesList() {
			content.getHeadlinesList({}).then(res => {
				this.headlinesList = res.data.data.list
			})
		},
		getSlider() {
			content.getSliders({
				media_id: 0,
				size: 4
			}).then(res => {
				if (res.data.state == 1) {
					var list = res.data.data
					if (list.length > 4) {
						this.sliders = list.slice(0, 4)
					} else {
						this.sliders = list
					}
				}
			})
		},
		changeLabel(id, name) {
			if (this.params.type != id) {
				this.lable_name = name
				this.params.type = id
				if (name == '直播') {
					this.paramsl.page = 1
					this.list = []
					this.livelist = []
					this.params.source = 0
					this.getLiveList()
				} else {
					this.params.page = 1
					this.list = []
					this.livelist = []
					this.params.source = 0
					this.getHomeList()
				}
			}

			// this.params.index_label=id

		},
		changeChildLabel(id) {
			if (this.params.source != id) {
				this.params.page = 1
				this.params.source = id
				this.list = []
				this.livelist = []
				this.getHomeList()
			}

		},
		onLoad() {
			this.params.user_id = this.user ? this.user.id : 0
			if (this.params.page > 0) {
				setTimeout(() => {
					this.params.page += 1
					this.getHomeList()
				}, 500);
			}

		},
		onLoadl() {
			if (this.paramsl.page > 0) {
				setTimeout(() => {
					this.paramsl.page += 1
					this.getLiveList()
				}, 500);
			}

		}
	}
}
</script>
<style lang="scss">
.homedemo_pages {
	background-color: #ffffff;

	.home_top_block {
		padding: 10px;

		.home_top_search_box {
			color: #333333;
			font-size: 12px;
			text-align: center;
			padding: 13px 0;
			margin: 0 17px;
			margin-bottom: 10px;
			border-radius: 28px;
			border: 1px solid #C3C3C3;
		}

		.swiper_box {
			width: 100%;
			height: 230px;
			margin-top: 10px;

			.my_swipe {
				width: 100%;
				height: 230px;

				.swipe_img {
					width: 100%;
					height: 230px;
					display: block;
					object-fit: cover;
				}

				.van-swipe__indicator {
					width: 15px;
					height: 3px;
					border-radius: 3px;
					background-color: #ffffff;
					opacity: 1;
				}
			}
		}

		.home_headline_box {
			display: flex;
			align-items: center;
			margin-top: 20px;
			padding: 14px 8px;
			border-radius: 3px;
			background: linear-gradient(to right, #FFF4EC, #ffffff);

			.home_headline_icon_box {
				width: 53px;
				height: 18px;
			}

			.home_headline_icon {
				width: 53px;
				height: 18px;
			}

			.home_headline_title_box {
				width: 100%;
				flex: 1;
				font-size: 14px;
				height: 18px;
				overflow: hidden;
				padding-left: 10px;

				.my_swipe {
					height: 17px;
				}

				a {
					color: #333333;
				}

				.home_headline_cell_left {
					width: 50%;
				}

				.home_headline_cell_right {
					width: 50%;
				}

				.home_headline_article_block {
					height: 17px;
					width: 100%;
				}
			}
		}
	}

	.home_list_box {


		.home_channel_box {
			position: sticky;
			top: 0;
			left: 0;
			right: 0;
			background-color: #ffffff;
			z-index: 2;
			width: 100%;
			padding: 10px 0;

			.home_channel_cell {
				cursor: pointer;
				text-align: center;

				.home_channel_title {
					color: #666666;
					font-size: 13px;
					padding: 5px 13px;
					border-right: 1px solid #F4F4F4;
				}

				.home_channel_title_def {
					color: #9a9a9a;
					font-size: 13px;
					padding: 5px 13px;
					border-right: 1px solid #F4F4F4;
				}

				.home_channel_title_on {
					color: #333333;
				}

				.home_channel_border_on {
					width: 21px;
					height: 6px;
					background-color: #FFBB00;
					border-radius: 3px;
					margin: 0 auto;
				}

				.home_channel_border {
					width: 10px;
					height: 3px;
				}
			}

			.home_channel_cell:last-child .home_channel_title {
				border-right: 0px solid #F4F4F4;
				;
			}
		}





		.artlcie_list_box {
			padding: 10px;
			margin-top: 5px;

			.list_bigimg_top {
				display: flex;
				align-items: center;

				.artlcie_list_title {
					color: #333333;
					font-size: 15px;
					font-weight: bold;

				}

				.artlcie_list_type_icon {
					width: 35px;
					height: 15px;
					margin-left: 5px;
					vertical-align: middle;
				}
			}

			.artlcie_list_desc {
				color: #666666;
				font-size: 12px;
				margin-top: 4px;
			}

			.artlcie_list_cell:first-child {
				padding-top: 0;
			}

			.artlcie_list_cell {
				cursor: pointer;
				padding-top: 15px;
				padding-bottom: 15px;
				border-bottom: 1px solid #E1E1E1;

				.list_bigimg_center {
					position: relative;
					margin-top: 15px;
					width: 100%;
					height: 200px;

					.list_bigimg_img {
						width: 100%;
						height: 200px;
						object-fit: cover;
					}

					.list_bigimg_inicon {
						position: absolute;
						top: 15px;
						left: 15px;
						width: 100px;
						height: 25px;
						z-index: 1;
					}

					.list_bigimg_player {
						position: absolute;
						top: 35%;
						bottom: 0;
						right: 0;
						left: 0;
						width: 60px;
						height: 60px;
						z-index: 1;
						margin: 0 auto;
					}
				}

				.list_bigimg_bottom {
					color: #999999;
					margin-top: 15px;
					display: flex;
					align-items: center;

					.read_icon {
						width: 11px;
						height: 7px;
						margin-right: 3px;
						vertical-align: middle;
					}

					.comment_icon {
						width: 9px;
						height: 9px;
						color: #999999;
						margin-right: 3px;
						vertical-align: middle;
					}

					.list_bigimg_bottom_text {
						font-size: 10px;
						margin-right: 15px;
					}
				}

				.moreimg_cell {
					width: 100%;
					height: 100px;
					position: relative;

					.moreimg_img {
						width: 100%;
						height: 100px;
						object-fit: cover;
					}

				}
			}

			.samll_img_right_icon {
				width: 21px;
				height: 21px;
				position: absolute;
				right: 8px;
				bottom: 8px;
				z-index: 1;
			}
		}

		.artlcie_list_left {
			height: 100px;
			position: relative;

			.artlcie_list_left_bottom {
				color: #999999;
				display: flex;
				align-items: center;
				position: absolute;
				left: 0;
				bottom: 0;

				.read_icon {
					width: 11px;
					height: 7px;
					margin-right: 3px;
					vertical-align: middle;
				}

				.comment_icon {
					width: 9px;
					height: 9px;
					color: #999999;
					margin-right: 3px;
					vertical-align: middle;
				}

				.list_bigimg_bottom_text {
					font-size: 10px;
					margin-right: 12px;
				}
			}
		}
	}
}
</style>